// extracted by mini-css-extract-plugin
module.exports = {"meals-summary":"MealsSummary_meals-summary__Sf6kd"};